import React from 'react';
import './App.css';

import TypeList from './TypeList';
import DocsForType from './DocsForType';

import {BrowserRouter, Route} from 'react-router-dom'

const typesData = require('./types.json');
const types = {};

for (let type of typesData.types) {
  types[type.name] = type;
}

function App(props) {
  return (
    <BrowserRouter>
        <div>
          <p>
            This is a WIP experiment, the current working doc viewers lives at <a href="docs.perl6.org">docs.perl6.org</a>
          </p>
          <p>
            You can Collapse/expand all sections by pressing +
          </p>
          <Route exact path="/" render={props => <TypeList types={types}/>}/>
          <Route path="/type/:name" render={props => <DocsForType types={types} {...props}/>}/>
        </div>
    </BrowserRouter>
  );
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js